export var RadioButtonStylePropertiesByVariant = {
    default: function (theme) { return ({
        width: '100%',
        height: '24px',
        padding: '0px 12px',
        borderColor: theme.borderPrimary,
        backgroundColor: theme.backgroundUI,
        color: theme.contentAccent,
        checkedBackgroundColor: theme.contentAccent,
        checkedColor: theme.backgroundUI,
        hoverBackgroundColor: theme.hoverHighlight,
    }); },
    /* @deprecated this is old styling */
    orange: function (theme) { return ({
        width: '24px',
        height: '24px',
        padding: '0px',
        borderColor: theme.recordsFinancial,
        color: theme.recordsFinancial,
        checkedBackgroundColor: theme.recordsFinancial,
        checkedColor: theme.backgroundUI,
        hoverBackgroundColor: theme.backgroundPrimary,
    }); },
};
//# sourceMappingURL=RadioButtonVariants.js.map